import http from '@/utils/request.js'

export const reqGetSuggestion = (keyword) => {
  return http({
    method: 'get',
    url: '/app/v1_0/suggestion',
    params: {
      q: keyword
    }
  })
}

/**
 * 获取关键字搜索结果
 * @param {*} q 关键字
 * @param {*} page  第几页
 */
export const reqGetSearch = (q, page) => {
  return http({
    method: 'get',
    url: '/app/v1_0/search',
    params: {
      q,
      page

    }
  })
}
